import { useDispatch } from "react-redux";
import { toast } from "react-toastify";

import { createEntity } from "@/services/API/shared";
import {
    setLocalLoading,
    setIsVisibleDentalFormulaModal,
    setLoading,
} from "@/store/ui/ui";
import { setGlobalDate } from "@/store/schedule/scheduleSlice";
import { updateNewAppointment } from "@/store/appointments/appointmentsSlice";
import { addItemToData } from "@/store/data/dataSlice";
import { dateFormatter } from "@/utils/dateFormatter";
import { addDentalFormula } from "@/store/patients/patients";
import { addNewService } from "@/store/service/service";

import { IHandleCreateParams } from "@/shared/interfaces/patientPage";

export default function useCreateNewEntity() {
    const dispatch = useDispatch();

    const globalLoadingEntities = new Set(["appointments"]);

    const entityHandlers: Record<string, (data: any) => void> = {
        "patients/dentalformula": data => {
            dispatch(addDentalFormula(data));
            dispatch(setIsVisibleDentalFormulaModal(false));
        },
        "users/createemployee": data => {
            dispatch(addItemToData(data));
        },
        patients: data => {
            dispatch(setIsVisibleDentalFormulaModal(false));
            dispatch(addItemToData(data));
            dispatch(
                updateNewAppointment({
                    patientId: data._id,
                    patientName: data.name,
                }),
            );
        },
        services: data => {
            dispatch(addNewService(data));
        },
    };

    async function handleCreate({
        entity,
        data,
        message,
        onSuccess,
    }: IHandleCreateParams) {
        const isGlobal = globalLoadingEntities.has(entity);
        dispatch(isGlobal ? setLoading(true) : setLocalLoading(true));

        const response = await createEntity(entity, data);

        if (response?.status === "success" && response.data) {
            entityHandlers[entity]?.(response.data);
            onSuccess?.();
            toast.success(message);
        } else if (response?.message) {
            const msg = response.message;
            if (msg.includes("duplicate key")) {
                toast.error("Пацієнт з такими даними вже існує");
            } else {
                toast.error(msg || "Помилка під час створення");
            }
        }

        dispatch(isGlobal ? setLoading(false) : setLocalLoading(false));
        dispatch(setGlobalDate(dateFormatter(new Date())));
    }

    return { handleCreate };
}
